import { toast } from 'react-toastify';

// react-toastify 5 does not export this type. Take it from the method so
// `position` stays the allowed literal instead of widening to `string`.
type ToastOptions = NonNullable<Parameters<typeof toast.success>[1]>;
type ToastContent = Parameters<typeof toast.success>[0];

const toasts: Record<string, typeof toast.success> = {
    success: toast.success,
    warn: toast.warn,
    error: toast.error,
    info: toast.info,
};

// v5 can't cap the stack, so a new toast dismisses the previous one. Each toast
// still opens fresh, so it plays its enter animation and none is lost to an update.
let lastToastId: ReturnType<typeof toast.success> | undefined;

const sendToast = (type: string = 'warn', message: ToastContent, options: ToastOptions = {}) => {
    if (!Object.prototype.hasOwnProperty.call(toasts, type)) return;

    const toastOptions: ToastOptions = {
        position: 'bottom-center',
        autoClose: 5000,
        hideProgressBar: true,
        draggable: true,
        ...options,
        // A click closes the toast before React 16 runs a button inside it.
        // pauseOnHover also latches on after a phone tap.
        closeOnClick: false,
        pauseOnHover: false,
    };

    if (lastToastId !== undefined) toast.dismiss(lastToastId);
    lastToastId = toasts[type](message, toastOptions);
};

export default sendToast;
